import { Component, computed, inject, input } from '@angular/core';
import { I18nService } from '@lp-ui-lib';
import { Icons } from '@lp-ui-lib';
import { I18n_keys } from '@lp-ui-lib';
@Component({
  selector: 'app-htst-info-data-em',
  imports: [],
  templateUrl: './htst-info.html',
  styleUrls: ['./htst-info.scss'],
})
export class HtstInfoDataEMComponent {
  readonly icon = Icons; // Prince check why we required here.
  public i18n = inject(I18nService);
  htstInfo = input<any>(null);
  sensorType = input<string>('');
  gatewayLabel = computed(() => this.i18n.langString(I18n_keys.GATEWAY_HTST));
  macAddressLabel = computed(() => this.i18n.langString(I18n_keys.MAC_ADDRESS));
  dauModelLabel = computed(() => this.i18n.langString(I18n_keys.DAU_MODEL));
  sensorColorLabel = computed(() => this.i18n.langString(I18n_keys.SENSOR_COLOR));
}
